import React, { createContext, useContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const RTLContext = createContext();

export const useRTL = () => {
  const context = useContext(RTLContext);
  if (!context) {
    throw new Error('useRTL must be used within an RTLProvider');
  }
  return context;
};

export const RTLProvider = ({ children }) => {
  const { i18n } = useTranslation();
  const [direction, setDirection] = useState(() => {
    const savedLang = localStorage.getItem('i18nextLng') || 'en';
    return ['ps', 'dr'].includes(savedLang) ? 'rtl' : 'ltr';
  });

  const updateDirection = (language) => {
    const newDirection = ['ps', 'dr'].includes(language) ? 'rtl' : 'ltr';
    setDirection(newDirection);
    localStorage.setItem('direction', newDirection);
  };

  const toggleDirection = () => {
    const newDirection = direction === 'ltr' ? 'rtl' : 'ltr';
    setDirection(newDirection);
    localStorage.setItem('direction', newDirection);
  };

  useEffect(() => {
    document.body.dir = direction;
    document.documentElement.dir = direction;
  }, [direction]);

  useEffect(() => {
    const handleLanguageChange = (lng) => {
      updateDirection(lng);
    };
    
    i18n.on('languageChanged', handleLanguageChange);
    return () => i18n.off('languageChanged', handleLanguageChange);
  }, [i18n]);

  const value = {
    direction,
    setDirection,
    toggleDirection,
    updateDirection,
    isRTL: direction === 'rtl'
  };

  return (
    <RTLContext.Provider value={value}>
      {children}
    </RTLContext.Provider>
  );
};